import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import './MorePage.css';
import Header from './components/Header';
import Post from './components/Post';
import {
  getPwaInstallState,
  promptPwaInstall,
  subscribeToPwaInstallState,
} from './components/PwaInstall';
import {
  MdDescription,
  MdAttachMoney,
  MdAddCircleOutline,
  MdMoneyOff,
  MdVpnKey,
  MdGavel,
  MdExitToApp,
  MdHistory,
  MdGetApp,
} from 'react-icons/md';
import {FaWhatsapp} from 'react-icons/fa';

const More = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [setting, setSetting] = useState(null);
  const [visible, setVisible] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [oldPasswordShow, setOldPasswordShow] = useState(true);
  const [newPasswordShow, setNewPasswordShow] = useState(true);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [showInstallGuide, setShowInstallGuide] = useState(false);
  const [isIos, setIsIos] = useState(false);
  const [installState, setInstallState] = useState(getPwaInstallState);
  const {prompt: installPrompt, isInstalled} = installState;

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user'));
    const settingData = JSON.parse(localStorage.getItem('setting'));

    if (userData) setUser(userData);
    if (settingData) setSetting(settingData.help);
  }, []);

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    const iosDevice =
      /iPad|iPhone|iPod/.test(userAgent) ||
      (window.navigator.platform === 'MacIntel' &&
        window.navigator.maxTouchPoints > 1);
    setIsIos(iosDevice);
    return subscribeToPwaInstallState(() =>
      setInstallState(getPwaInstallState()),
    );
  }, []);

  const addToHomeScreen = async () => {
    if (isInstalled) return;

    if (installPrompt) {
      try {
        await promptPwaInstall();
      } catch (error) {
        setShowInstallGuide(true);
      }
      return;
    }

    setShowInstallGuide(true);
  };

  const logout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      navigate('/');
    }
  };

  const openWhatsApp = () => {
    if (setting && setting.text) {
      const phoneNumber = setting.text;
      const message = 'Hello, I need help';
      const whatsappUrl = `https://wa.me/91${phoneNumber}?text=${encodeURIComponent(
        message,
      )}`;
      window.open(whatsappUrl, '_blank');
    } else {
      alert('Help contact not available');
    }
  };

  const changePassword = async () => {
    if (!oldPassword) {
      alert('Old Password is required');
      return;
    }
    if (!newPassword) {
      alert('New Password is required');
      return;
    }

    setLoading(true);
    try {
      const res = await Post.ChangePassword({
        old_password: oldPassword,
        new_password: newPassword,
      });

      setLoading(false);

      if (res.error) {
        setErrorMsg(res.errorMsg);
        alert(res.errorMsg);
      } else {
        setVisible(false);
        setOldPassword('');
        setNewPassword('');
        alert('Password changed successfully!');
      }
    } catch (e) {
      setLoading(false);
      alert('Something went wrong');
    }
  };

  return (
    <div className="more-page">
      {loading && <div className="overlay">Loading...</div>}

      <Header title="More" />

      <div className="install-option-row">
        <button
          className="install-option"
          type="button"
          onClick={addToHomeScreen}
          disabled={isInstalled}>
          <MdGetApp size={26} />
          <span>
            {isInstalled ? 'Added to Home Screen' : 'Add to Home Screen'}
          </span>
        </button>
      </div>

      {/* Options */}
      <div className="options-container">
        <button onClick={() => navigate('/playHistory')} className="option-btn">
          <MdHistory size={30} color="#fff" />
          <p>My Play History</p>
        </button>

        <button onClick={() => navigate('/passbook')} className="option-btn">
          <MdDescription size={24} />
          <p>Statement</p>
        </button>
      </div>

      <div className="options-container">
        <button onClick={() => navigate('/win')} className="option-btn">
          <MdAttachMoney size={24} />
          <p>My Winnings</p>
        </button>

        <button
          onClick={() => navigate('/AddMoneyList')}
          className="option-btn">
          <MdAddCircleOutline size={24} />
          <p>Add Money List</p>
        </button>
      </div>

      <div className="options-container">
        <button
          onClick={() => navigate('/WithdrawList')}
          className="option-btn">
          <MdMoneyOff size={24} />
          <p>Withdraw Money List</p>
        </button>

        <button onClick={() => setVisible(true)} className="option-btn">
          <MdVpnKey size={24} />
          <p>Change Password</p>
        </button>
      </div>

      <div className="options-container">
        <button onClick={() => navigate('/page')} className="option-btn">
          <MdGavel size={24} />
          <p>Terms & Condition</p>
        </button>

        {setting ? (
          <button onClick={openWhatsApp} className="option-btn">
            <FaWhatsapp size={24} color="#fff" />
            <p>Help</p>
          </button>
        ) : (
          <button onClick={logout} className="option-btn">
            <MdExitToApp size={24} />
            <p>Logout</p>
          </button>
        )}
      </div>

      {/* If help button is shown, logout goes in a new row */}
      {setting && (
        <div className="options-container">
          <button onClick={logout} className="option-btn1">
            <MdExitToApp size={24} />
            <p>Logout</p>
          </button>
        </div>
      )}

      {/* Change Password Modal */}
      {visible && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Change Password</h2>
            {errorMsg && <p className="error-msg">{errorMsg}</p>}

            <div className="field">
              <input
                type={oldPasswordShow ? 'password' : 'text'}
                placeholder="Old Password"
                value={oldPassword}
                onChange={e => setOldPassword(e.target.value)}
              />
              <button
                className="showhide"
                onClick={() => setOldPasswordShow(!oldPasswordShow)}>
                {oldPasswordShow ? 'Show' : 'Hide'}
              </button>
            </div>

            <div className="field">
              <input
                type={newPasswordShow ? 'password' : 'text'}
                placeholder="New Password"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
              />
              <button
                className="showhide2"
                onClick={() => setNewPasswordShow(!newPasswordShow)}>
                {newPasswordShow ? 'Show' : 'Hide'}
              </button>
            </div>

            <div className="modal-actions">
              <button onClick={() => setVisible(false)}>Cancel</button>
              <button onClick={changePassword}>Change Now</button>
            </div>
          </div>
        </div>
      )}

      {showInstallGuide && (
        <div
          className="install-guide-overlay"
          onClick={() => setShowInstallGuide(false)}>
          <section
            className="install-guide"
            role="dialog"
            aria-modal="true"
            aria-labelledby="install-guide-title"
            onClick={event => event.stopPropagation()}>
            <h2 id="install-guide-title">Add SS Company to Home Screen</h2>
            {isIos ? (
              <ol>
                <li>Open this page in Safari.</li>
                <li>Tap Share, then choose Add to Home Screen.</li>
                <li>Tap Add to finish.</li>
              </ol>
            ) : (
              <p>
                Open your browser menu and choose Install app or Add to Home
                Screen.
              </p>
            )}
            <button type="button" onClick={() => setShowInstallGuide(false)}>
              Got it
            </button>
          </section>
        </div>
      )}
    </div>
  );
};

export default More;
